import { Box, Icon } from '@palmetto/palmetto-components';

import { compareNormalizedValues } from 'types';

interface SummaryRowProps {
  label: string;
  value: string | number | null | undefined;
  expectedValue?: string | number | null | undefined;
}

export const SummaryRow: React.FC<SummaryRowProps> = ({ label, value, expectedValue }: SummaryRowProps) => {
  // Check if expected value is explicitly an empty string (shows question mark)
  const isEmptyString = expectedValue === '';

  // Treat empty string as null for comparison purposes
  const normalizedExpectedValue = isEmptyString ? null : expectedValue;

  // Only hide the row if both value and normalized expected value are absent
  if (!value && normalizedExpectedValue === null && !isEmptyString) {
    return null;
  }

  return (
    <Box direction="row" gap="md">
      <Box fontWeight="medium" width="40%">
        {label}
      </Box>
      <Box direction="row" width="50%">
        {value}
      </Box>

      <Box fontSize="sm" width="10%">
        {isEmptyString ? (
          <Icon name="c-question" color="grey-500" />
        ) : normalizedExpectedValue !== null && normalizedExpectedValue !== undefined ? (
          compareNormalizedValues(value, normalizedExpectedValue, true) ? (
            <Icon name="check" color="success-500" />
          ) : (
            <Icon name="remove" color="danger-500" />
          )
        ) : null}
      </Box>
    </Box>
  );
};
